// extracted by mini-css-extract-plugin
export default {"emailSuffixes":"EmailSuffixes_emailSuffixes__seGyo","addButton":"EmailSuffixes_addButton__esFC6"};